import React, { useEffect } from 'react';
import {
  XLg,
  PersonCheck,
  Stars,
  Megaphone,
  CameraVideo,
  ChatSquareText,
  Send,
  Wallet2,
} from 'react-bootstrap-icons';
import { useLocale } from '../i18n/LocaleContext';
import './HowItWorksModal.scss';

// A short in-app tutorial explaining the full creator flow: application →
// selection → briefs → create → review → publish → monthly payout. Pure UI /
// static content; opens from the dashboard top bar.
const STEPS = [
  { key: 'apply', Icon: PersonCheck },
  { key: 'select', Icon: Stars },
  { key: 'brief', Icon: Megaphone },
  { key: 'create', Icon: CameraVideo },
  { key: 'review', Icon: ChatSquareText },
  { key: 'publish', Icon: Send },
  { key: 'payout', Icon: Wallet2 },
];

export default function HowItWorksModal({ open, onClose }) {
  const { t } = useLocale();

  // Close on Escape; lock body scroll while open.
  useEffect(() => {
    if (!open) return undefined;
    function onKey(e) {
      if (e.key === 'Escape') onClose();
    }
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="how-modal" role="dialog" aria-modal="true" onClick={onClose}>
      <div className="how-modal__panel" onClick={(e) => e.stopPropagation()}>
        <button
          type="button"
          className="how-modal__close"
          onClick={onClose}
          aria-label={t('how.close')}
        >
          <XLg size={18} />
        </button>

        <h2 className="how-modal__title">{t('how.modalTitle')}</h2>
        <p className="how-modal__lead">{t('how.modalLead')}</p>

        <ol className="how-modal__steps">
          {STEPS.map(({ key, Icon }, i) => (
            <li className="how-step" key={key}>
              <span className="how-step__icon">
                <Icon size={18} />
              </span>
              <div className="how-step__body">
                <div className="how-step__head">
                  <span className="how-step__num">{i + 1}</span>
                  <h3 className="how-step__title">{t(`how.step.${key}.title`)}</h3>
                </div>
                <p className="how-step__text">{t(`how.step.${key}.body`)}</p>
              </div>
            </li>
          ))}
        </ol>

        <div className="how-modal__foot">
          <button type="button" className="btn-o btn-o--dark" onClick={onClose}>
            {t('how.gotIt')}
          </button>
        </div>
      </div>
    </div>
  );
}
